import './index.css';
import React from 'react';
import classnames from 'classnames';
import randomstring from 'randomstring';

var styles = {"fill-politico-red":"politico_style___30_exgCxIJ","styles":"politico_style___18KvUvfWYa"};

var Ad = function Ad(props) {
  return React.createElement("div", {
    className: classnames('ad-container', styles.styles)
  }, React.createElement("div", {
    className: "content-group ad screenshot-remove"
  }, React.createElement("p", null, "Advertisement"), React.createElement("div", {
    className: "ad-slot flex horizontal",
    id: props.adID
  })));
};

Ad.defaultProps = {
  adID: 'pol-02'
};

var Banner = function Banner() {
  return React.createElement(Ad, {
    adID: "pol-01"
  });
};

var Cube1 = function Cube1() {
  return React.createElement(Ad, {
    adID: "pol-02"
  });
};

var Cube2 = function Cube2() {
  return React.createElement(Ad, {
    adID: "pol-05"
  });
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var Ad$1 =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Ad, _React$PureComponent);

  function Ad(props) {
    var _this;

    _classCallCheck(this, Ad);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Ad).call(this, props));
    _this.state = {
      id: null
    };
    _this.mountAd = _this.mountAd.bind(_assertThisInitialized(_this));
    _this.waitForAdScript = _this.waitForAdScript.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Ad, [{
    key: "mountAd",
    value: function mountAd() {
      if (window.generateCustomAds) {
        window.generateCustomAds("#".concat(this.state.id), this.props.type);
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "waitForAdScript",
    value: function waitForAdScript() {
      var _this2 = this;

      this.waiting = setInterval(function () {
        var success = _this2.mountAd();

        if (success) {
          clearInterval(_this2.waiting);
        }
      }, 2000);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var idNum = randomstring.generate({
        length: 12,
        charset: 'alphabetic'
      });
      this.setState({
        id: "ad-".concat(idNum)
      }, function () {
        var success = _this3.mountAd();

        if (!success) {
          _this3.waitForAdScript();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: classnames('ad-container', styles.styles)
      }, React.createElement("div", {
        className: "content-group ad screenshot-remove"
      }, React.createElement("p", null, "Advertisement"), React.createElement("div", {
        className: "ad-slot flex horizontal",
        id: this.state.id
      })));
    }
  }]);

  return Ad;
}(React.PureComponent);

Ad$1.defaultProps = {
  type: 'cube'
};

var SuperCube1 = function SuperCube1() {
  return React.createElement(Ad, {
    adID: "pol-06"
  });
};

var SuperCube2 = function SuperCube2() {
  return React.createElement(Ad, {
    adID: "pol-07"
  });
};

var SuperCube3 = function SuperCube3() {
  return React.createElement(Ad, {
    adID: "pol-08"
  });
};

var SuperCube4 = function SuperCube4() {
  return React.createElement(Ad, {
    adID: "pol-09"
  });
};

var index = {
  Banner: Banner,
  Cube1: Cube1,
  Cube2: Cube2,
  Dynamic: Ad$1,
  Static: Ad,
  SuperCube1: SuperCube1,
  SuperCube2: SuperCube2,
  SuperCube3: SuperCube3,
  SuperCube4: SuperCube4
};

export default index;
